<template><v-container fluid class="chat-application pa-0">
  <v-dialog v-model="showDeleteConfirm" max-width="400">

    <v-card class="rounded-xl elevation-5">

      <v-card-title class="text-h5 bg-error text-white rounded-t-xl py-4">

        <v-icon icon="mdi-alert-circle" class="me-2"></v-icon>

      {{ t('chat.confirmDeletion') }}

      </v-card-title>

      <v-card-text class="pa-6 text-body-1">

        {{ t('chat.areYouSureYouWantToDeleteThisConversationThisActionCannotBeUndone') }}

      </v-card-text>

      <v-card-actions class="pa-4 pb-6">

        <v-spacer></v-spacer>

        <v-btn color="grey-darken-1" variant="text" @click="showDeleteConfirm = false" rounded="pill" class="px-5">

          {{ t('generic.cancel') }}

        </v-btn>

        <v-btn

            color="error"

            variant="elevated"

            @click="confirmDelete"

            rounded="pill"

            class="px-5"

            :loading="deletingConversation"

        >

          <v-icon start icon="mdi-delete" class="me-1"></v-icon>

          {{ t('generic.delete') }}

        </v-btn>

      </v-card-actions>

    </v-card>

  </v-dialog>



  <v-snackbar

      v-model="showSnackbar"

      :color="snackbarColor"

      :timeout="3000"

      location="top"

      rounded="pill"

      elevation="4"

      class="pa-3"

  >

    <div class="d-flex align-center">

      <v-icon class="me-3" :icon="snackbarIcon"></v-icon>

      <span class="text-subtitle-1 font-weight-medium">{{ snackbarText }}</span>

    </div>

    <template v-slot:actions>

      <v-btn

          variant="text"

          icon="mdi-close"

          @click="showSnackbar = false"

      ></v-btn>

    </template>

  </v-snackbar>





  <v-sheet

      color="primary"

      class="py-8 mb-8"

      rounded="0"

      elevation="1"

  >

    <v-row justify="center" class="text-center mt-2">

      <v-icon icon="mdi-chat-processing" size="56" color="white" class="mb-4"></v-icon>

      <h1 class="text-h3 font-weight-light text-white">{{ t('chat.chatWithPersonas') }}</h1>

    </v-row>

  </v-sheet>


  <v-row class="ma-0 pa-4" style="max-width: 1600px; margin: 0 auto !important;">
    <v-col cols="12" md="8" lg="9" class="pa-2">
      <v-select
          class="domain-select"
          :label="$t('generic.domain')"
          :items="domainOptions"
          item-title="title"
          item-value="value"
          v-model="selectedDomain"
          density="default"
          variant="outlined"
          color="primary"
          prepend-inner-icon="mdi-domain"
          hide-details
      />
    </v-col>
    <v-col cols="12" md="4" lg="3" class="pa-2 d-flex align-center">
      <v-btn
          @click="filterDialogOpen = true"
          prepend-icon="mdi-filter-variant"
          variant="tonal"
          color="primary"
          block
      >
        {{ t('personagrid.filterButton') }}
        <v-badge
            v-if="activeFilterCount"
            :content="activeFilterCount"
            color="error"
            inline
            class="ms-2"
        />
      </v-btn>
    </v-col>
  </v-row>

  <v-alert
      v-if="showNoFilterResults"
      type="info"
      variant="tonal"
      class="mx-4 mb-2"
      style="max-width: 1600px; margin: 0 auto !important;"
  >
    {{ t('personagrid.noPersonasMatchFilters') }}
  </v-alert>

  <FilterSettingsDialog
      v-model="filterDialogOpen"
      :domain="selectedDomain"
      :personas="staticPersonasForFilter"
      :generated-personas="generatedPersonasForFilter"
      :chat-api-personas="personas"
      :is-generated="false"
      :applied-criteria="activeFilterCriteria"
      :schema-attributes="schemaAttributes"
      @apply="onApplyFilters"
      @clear="onClearFilters"
  />

  <v-row justify="center" class="ma-0 pa-4" style="max-width: 1600px; margin: 0 auto !important;">

    <v-col cols="12" md="4" lg="3" class="pa-2">

      <v-card rounded="lg" elevation="3" class="sidebar-card h-100">

        <v-card-item class="bg-primary-lighten-5 rounded-t-lg">

          <v-card-title class="d-flex align-center pb-1">

            <v-icon icon="mdi-account-circle" class="me-2" color="primary"></v-icon>

            <span class="text-primary">{{ t('chat.personaSelection') }}</span>

          </v-card-title>

          <v-select

              v-model="selectedPersona"

              :items="filteredChatPersonas"

              item-title="name"

              item-value="persona_id"

              variant="outlined"

              density="comfortable"

              color="primary"

              bg-color="white"

              hide-details

              class="my-2"

              rounded="lg"

          ></v-select>

        </v-card-item>



        <v-divider></v-divider>



        <v-card-item>

          <v-card-title class="d-flex align-center">

            <v-icon icon="mdi-history" class="me-2" color="primary"></v-icon>

            <span class="text-primary">{{ t('chat.conversations') }}</span>

          </v-card-title>

        </v-card-item>



        <v-card-text class="pa-0">

          <div v-if="!loadingThreads" class="conversations-container pa-2">

            <v-list class="conversations-list bg-transparent pa-0">

              <v-list-item

                  v-for="thread in thread_ids"

                  :key="thread.thread_id"

                  @click="selectedThreadId = thread.thread_id; loadMessages(thread.thread_id)"

                  :active="selectedThreadId === thread.thread_id"

                  :class="{ 'rounded-lg': true, 'bg-primary-lighten-3': selectedThreadId === thread.thread_id }"

                  class="mb-2 conversation-item"

                  rounded="lg"

                  elevation="1"

              >

                <template v-slot:prepend>

                  <v-icon icon="mdi-message-text" color="primary" class="me-2"></v-icon>

                </template>

                <v-list-item-title class="text-subtitle-1">{{ formattedThreadTimestamp(thread.timestamp) }}</v-list-item-title>

                <template v-if="thread.thread_id !== 'New Conversation'" v-slot:append>

                  <v-btn

                      icon="mdi-delete-outline"

                      color="error"

                      size="small"

                      variant="text"

                      @click.stop="promptDeleteConversation(thread.thread_id, selectedPersona)"

                  ></v-btn>

                </template>

              </v-list-item>



              <v-card

                  class="text-center pa-4 mt-4"

                  v-if="thread_ids.length === 1"

                  variant="outlined"

                  color="grey-lighten-3"

                  rounded="lg"

              >

                <v-icon icon="mdi-chat-plus" size="large" color="grey" class="mb-2"></v-icon>

                <div class="text-subtitle-1 text-medium-emphasis">{{ t('chat.noConversationsYet') }}</div>

                <div class="text-caption text-medium-emphasis">{{ t('chat.selectAPersonaAndStartChatting') }}</div>

              </v-card>

            </v-list>

          </div>



          <div v-else class="pa-6 text-center">

            <v-progress-circular indeterminate color="primary" class="mb-3"></v-progress-circular>

            <div class="text-subtitle-1 text-medium-emphasis">{{ t('chat.loadingConversations') }}</div>

          </div>

        </v-card-text>

      </v-card>

    </v-col>



    <v-col cols="12" md="8" lg="9" class="pa-2">

      <v-card rounded="lg" elevation="3" class="chat-card d-flex flex-column" min-height="650px">

        <v-card-item class="bg-primary-lighten-5 rounded-t-lg">

          <div class="header" style="display: flex; justify-content: space-between">

            <v-card-title class="d-flex align-center">

              <v-avatar color="primary" class="me-3">

                <v-icon icon="mdi-account" color="white"></v-icon>

              </v-avatar>

              <div class="header-title-text" style="display: flex; flex-direction: column;">

                <div class="text-h6">{{ selectedPersonaName || t('chat.selectAPersona') }}</div>

                <div class="text-caption text-medium-emphasis">

                  {{ selectedThreadId ? (selectedThreadId === 'New Conversation' ? t('chat.startANewConversation') : formattedThreadTimestamp(getThreadTimestamp(selectedThreadId))) : t('chat.noConversationSelected') }}

                </div>

              </div>

            </v-card-title>


            <div class="header-actions">

              <v-btn

                  @click="removeUploadedFile"

                  :disabled="!(uploaded_file.length > 0)"

                  :icon="'mdi-delete-circle-outline'"

                  elevation="0"

                  style="background-color: inherit"
              >

              </v-btn>

            </div>

          </div>


        </v-card-item>



        <div class="flex-grow-1 overflow-y-auto px-3 py-4 messages-container bg-grey-lighten-5">

          <div v-if="messages.length === 0" class="d-flex flex-column align-center justify-center h-100">

            <v-icon icon="mdi-message-text-outline" size="64" color="grey-lighten-1" class="mb-4"></v-icon>

            <div class="text-h6 text-medium-emphasis">{{ t('chat.noMessagesYet') }}</div>

            <div class="text-subtitle-2 text-medium-emphasis">{{ t('chat.startAConversationBySendingAMessage') }}</div>

          </div>



          <div v-else class="messages-list">

            <div

                v-for="(message, index) in messages"

                :key="index"

                class="message-wrapper"

                :class="message.sender === 'You' ? 'user-message-wrapper' : 'bot-message-wrapper'"

            >

              <v-card

                  class="message-card mb-4 elevation-1"

                  :class="message.sender === 'You' ? 'user-message' : (message.sender === 'System' ? 'system-message' : 'bot-message')"

                  rounded="lg"

                  variant="plain"

              >

                <v-card-item class="message-header py-1 px-3">

                  <v-card-title class="text-caption text-medium-emphasis pa-0">{{ message.sender }}</v-card-title>

                </v-card-item>

                <v-card-text class="pa-3 message-content">
                  <!-- Loaded from history: image kind -->
                  <a v-if="message.file_data && message.file_data.kind === 'image'" :href="message.file_data.urls[0]" target="_blank" rel="noopener noreferrer">
                    <v-img :src="message.file_data.urls[0]" min-width="500" class="mb-2" rounded cover></v-img>
                  </a>

                  <!-- Loaded from history: pdf/pptx kind — carousel through page/slide images -->
                  <div v-if="message.file_data && (message.file_data.kind === 'pdf' || message.file_data.kind === 'pptx')" class="mb-2" style="max-width: 500px;">
                    <v-carousel height="320" hide-delimiter-background show-arrows="hover" :continuous="false">
                      <v-carousel-item
                          v-for="(url, pi) in message.file_data.urls"
                          :key="pi"
                          :src="url"
                          cover
                      >
                        <template v-slot:placeholder>
                          <v-row class="fill-height ma-0" align="center" justify="center">
                            <v-progress-circular indeterminate color="primary"></v-progress-circular>
                          </v-row>
                        </template>
                      </v-carousel-item>
                    </v-carousel>
                    <div class="text-caption text-medium-emphasis mt-1">{{ message.file_data.urls.length }} {{ message.file_data.kind === 'pdf' ? t('chat.page') : t('chat.slide') }}{{ message.file_data.urls.length !== 1 ? 's' : '' }}</div>
                  </div>

                  <!-- Live upload: image preview (before history reload) -->
                  <a v-if="message.file_url && message.file_type && message.file_type.startsWith('image/')" :href="message.file_url" target="_blank" rel="noopener noreferrer">
                    <v-img :src="message.file_url" min-width="500" class="mb-2" rounded cover></v-img>
                  </a>

                  <div class="file-link-display d-flex align-center mb-2"
                       v-if="message.file_url && message.file_name && (!message.file_type || !message.file_type.startsWith('image/')) && !message.file">
                    <v-icon
                        icon="mdi-file-document-outline"
                        size="30"
                        class="me-3"
                        color="primary-darken-1"
                    ></v-icon>
                    <a :href="message.file_url" target="_blank" rel="noopener noreferrer" class="text-subtitle-1 font-weight-medium text-decoration-underline">
                      {{ message.file_name }}
                    </a>
                  </div>

                  <div class="media-downloader" v-if="message.file && message.sender === 'You' && (!message.file_type || !message.file_type.startsWith('image/'))">

                    <v-btn v-if="!downloading_spinner" style="background-color: white" icon="mdi-download" @click="downloadMedia(message.file, message.file_name)"></v-btn>

                    <v-progress-circular v-else indeterminate size="48"></v-progress-circular>

                    <p class="text-subtitle-1 text-truncate">{{message.file_name}}</p>

                  </div>

                  <div

                      class="message-text text-body-1 mt-2"

                      :class="message.sender === 'You' ? '' : 'ml-4'"

                      v-html="renderMarkdown(message.text)"  >

                  </div>

                </v-card-text>

              </v-card>

            </div>

          </div>

        </div>



        <v-card-actions class="pa-4 bg-white d-flex flex-column">

          <v-divider class="mb-3"></v-divider>

          <div class="d-flex align-center w-100">

            <file-upload

                :extensions="fu_config.extensions"

                :accept="fu_config.accept"

                :multiple="fu_config.multiple"

                v-model="uploaded_file"

                ref="image_uploader"

                class="custom-file-upload rounded-sm mr-2"

            >

              <v-btn icon>

                <v-badge v-if="uploaded_file.length > 0" :content="uploaded_file.length" color="green">

                  <v-icon size="large">mdi-paperclip</v-icon>

                </v-badge>

                <v-icon v-if="uploaded_file.length <= 0">mdi-paperclip</v-icon>

              </v-btn>

            </file-upload>

            <v-textarea
                v-model="question"
                :placeholder="$t('chat.typeYourMessageHere')"
                variant="outlined"
                rows="1"
                auto-grow
                max-rows="5"
                hide-details
                class="message-input rounded-lg me-2"
                density="comfortable"
                bg-color="grey-lighten-5"
                :disabled="!selectedPersona"

                @keydown.enter.exact.prevent="askPersona"

            ></v-textarea>

            <v-btn

                color="primary"

                @click="askPersona"

                :loading="loading"

                :disabled="!selectedPersona || !question"

                icon

                class="send-button ml-2"

                size="large"

                elevation="2"

                rounded="circle"

            >

              <v-icon>mdi-send</v-icon>

            </v-btn>

          </div>

          <div v-if="!selectedPersona" class="text-caption text-error mt-2">

            {{ t('chat.pleaseSelectAPersonaToStartChatting') }}

          </div>

        </v-card-actions>

      </v-card>


    </v-col>

  </v-row></v-container>
  <not-supported-snack :visible="snackbar_not_supported"></not-supported-snack>
  <downloaded-snack :visible="snackbar_downloaded"></downloaded-snack>
</template>
<script>
import { marked } from 'marked';
import FileUpload from 'vue-upload-component';
import { ask_persona, generate_new_thread_id, fetch_thread_ids, get_conversation_with_persona, fetch_persona_names, delete_thread_id, build_domain_options, get_default_domain } from "../api.js";
import {createCommentVNode, ref} from "vue";
import NotSupportedSnack from '@/components/NotSupportedSnack.vue';
import {InvalidCharacterError} from "core-js/internals/dom-exception-constants";
import DownloadedSnack from "@/components/DownloadedSnack.vue";
import FilterSettingsDialog from '@/components/FilterSettingsDialog.vue';
import {
  clearActiveFilterState,
  loadActiveFilterState,
  saveActiveFilterState,
} from '@/utils/filterStorage';
import {
  loadDomainPersonasWithOverlay,
  loadSavedPersonasForDomain,
  loadDomainSchemaAttributes,
} from '@/utils/personaDomainLoader';
import {
  filterChatPersonaOptions,
  getAllFilterFields,
  hasActiveCriteria,
  reconcileFilterCriteria,
  formatDroppedFilterFieldsMessage,
} from '@/utils/personaFilter';
import { useI18n } from "vue-i18n";
import { formatDateTime } from '@/utils/dateFormat';

export default {
  components: { DownloadedSnack, FileUpload, NotSupportedSnack, FilterSettingsDialog },
  setup() {
    const { t } = useI18n();

    return {
      t
    };
  },
  data() {
    return {
      personas: [], // List of personas
      selectedPersona: "", // Selected persona
      thread_ids: [], // List of thread_ids, now will store objects {thread_id, timestamp}
      selectedThreadId: "", // Selected thread_id
      question: "", // User's question
      loading: false, // Loading state for the button
      loadingThreads: false, // Loading state for thread IDs
      loadingMessages: false, // Loading state for messages
      messages: [], // Chat messages
// Delete confirmation
      showDeleteConfirm: false,
      threadToDelete: null,
      personaToDelete: null,
      deletingConversation: false,
// Toast notification
      showSnackbar: false,
      snackbarText: "",
      snackbarColor: "error",
      snackbarIcon: "mdi-alert-circle",
// Image Uploader
      fu_config: {
        extensions: '.jpeg,.png,.jpg,.pptx,.ppt,.pdf,.docx',
        accept: '.jpeg,.png,.jpg,.pptx,.ppt,.pdf,.docx',
        multiple: false,
      },
      uploaded_file: ref([]),
      uploaded_image_url: null,
      allowed_image_ext: ['.jpeg', '.png', '.jpg'],
      allowed_document_ext: ['.pdf','.docx','.ppt','.pptx'],
// SNACKBAR
      snackbar_not_supported: false,
      snackbar_downloaded: true,
//SPINNER
      downloading_spinner: false,

      // DOMAINS
      selectedDomain: get_default_domain(),
      filterDialogOpen: false,
      activeFilterCriteria: [],
      staticPersonasForFilter: [],
      generatedPersonasForFilter: [],
      schemaAttributes: [],
    };
  },
  computed: {
    filteredChatPersonas() {
      return filterChatPersonaOptions(this.personas, {
        staticPersonas: this.staticPersonasForFilter,
        generatedPersonas: this.generatedPersonasForFilter,
        criteria: this.activeFilterCriteria,
        schemaAttributes: this.schemaAttributes,
      });
    },
    currentFilterFields() {
      return getAllFilterFields(this.staticPersonasForFilter, false, this.schemaAttributes);
    },
    activeFilterCount() {
      return this.activeFilterCriteria.length;
    },
    showNoFilterResults() {
      if (!hasActiveCriteria(this.activeFilterCriteria, this.currentFilterFields)) {
        return false;
      }
      return this.personas.length > 0 && this.filteredChatPersonas.length === 0;
    },
    selectedPersonaName() {
      if (!this.selectedPersona) return null;
      const persona = this.personas.find(p => p.persona_id === this.selectedPersona);
      return persona ? persona.name : null;
    },
    domainOptions() {
      return build_domain_options(this.$t);
    },
  },
  methods: {
// Show a toast notification
    showToast(message, type = "error") {
      this.snackbarText = message;
      if (type === "error") {
        this.snackbarColor = "error";
        this.snackbarIcon = "mdi-alert-circle";
      } else if (type === "success") {
        this.snackbarColor = "success";
        this.snackbarIcon = "mdi-check-circle";
      } else if (type === "warning") {
        this.snackbarColor = "warning";
        this.snackbarIcon = "mdi-alert";
      } else if (type === "info") {
        this.snackbarColor = "info";
        this.snackbarIcon = "mdi-information";
      }
      this.showSnackbar = true;
    },
// Show delete confirmation dialog
    promptDeleteConversation(threadId, personaName) {
      this.threadToDelete = threadId;
      this.personaToDelete = personaName;
      this.showDeleteConfirm = true;
    },
// Confirm and execute the delete operation
    async confirmDelete() {
      if (!this.threadToDelete || !this.personaToDelete) {
        return;
      }
      this.deletingConversation = true;
      try {
        await delete_thread_id(this.threadToDelete, this.personaToDelete);
        this.loadThreadIds();
        if (this.selectedThreadId === this.threadToDelete) {
          this.selectedThreadId = 'New Conversation';
          this.messages = [];
        }
        this.showToast("Conversation deleted successfully.", "success");
      } catch (error) {
        console.error("Error deleting conversation:", error);
        this.showToast(this.$t('chat.failedToDeleteConversation'), "error");
      } finally {
        this.deletingConversation = false;
        this.showDeleteConfirm = false;
        this.threadToDelete = null;
        this.personaToDelete = null;
      }
    },
// Get thread timestamp by thread ID
    getThreadTimestamp(threadId) {
      if (threadId === "New Conversation") {
        return "New Conversation";
      }
      const thread = this.thread_ids.find(t => t.thread_id === threadId);
      return thread ? thread.timestamp : null;
    },
// Handle persona selection change
    handlePersonaChange() {
      this.loadThreadIds(); // Load thread IDs based on the selected persona
    },
// Fetch thread IDs for the selected persona
    async loadThreadIds() {
      if (!this.selectedPersona) {
        this.thread_ids = [];
        this.selectedThreadId = "";
        return;
      }
      this.loadingThreads = true;
      try {
        console.log("fetching thread is for persona: ", this.selectedPersona);
        const response = await fetch_thread_ids(this.selectedPersona); // Pass persona to fetch API
        let fetchedThreads = [];
        if (response && Array.isArray(response.data)) {
          fetchedThreads = response.data;
          console.log("fetched threads: ", response.data);
// Prepend "New Conversation" and set thread_ids
          this.thread_ids = [{ thread_id: "New Conversation", timestamp: "New Conversation" }, ...fetchedThreads];
// Set selectedThreadId to "New Conversation" by default
          this.selectedThreadId = "New Conversation";
        } else {
          throw new Error("Invalid response format");
        }
      } catch (error) {
        console.error("Error loading thread IDs:", error);
        this.thread_ids = [{ thread_id: "New Conversation", timestamp: "New Conversation" }];
        this.selectedThreadId = "New Conversation";
        this.showToast(this.$t('chat.failedToLoadConversations'), "error");
      } finally {
        this.loadingThreads = false;
      }
    },
    async fetchPersonaNames() {
      console.log('called fetchPersonaNames');
      try {
        const response = await fetch_persona_names(this.selectedDomain); // API call to fetch persona names
        if (response && Array.isArray(response.data)) {
          this.personas = response.data; // Update personas with fetched persona names
          this.ensureSelectedPersonaStillVisible();
        } else {
          throw new Error("Invalid response format");
        }
      } catch (error) {
        console.error("Error fetching personas:", error);
        this.personas = []; // Fallback to empty list
        this.showToast(this.$t('chat.failedToLoadPersonas'), "error");
      }
    },
    async loadFilterPersonaSources(domain, clearFilters = true) {
      if (clearFilters) {
        this.onClearFilters();
      }

      // Overlaid, not raw static: custom attributes added via Attribute
      // Management only exist on the backend documents, and the filter panel
      // discovers its fields from whatever personas it is given.
      this.staticPersonasForFilter = await loadDomainPersonasWithOverlay(domain, this.t);
      this.generatedPersonasForFilter = await loadSavedPersonasForDomain(domain);
      this.schemaAttributes = await loadDomainSchemaAttributes(domain);
    },
    // Persona Schema for the filter panel (Option 2: schema-driven,
    // type-aware custom attribute filters). Failure/empty schema is
    // handled gracefully — schemaAttributes stays [] and
    // getAllFilterFields() falls back to its existing data-driven
    // discovery, exactly as before this feature existed.
    async loadSchemaAttributes(domain) {
      try {
        const response = await fetch_persona_domain_schema(domain);
        this.schemaAttributes = response.data?.attributes || [];
      } catch (error) {
        console.error('Failed to load persona domain schema for filters:', error);
        this.schemaAttributes = [];
      }
    },
    restoreActiveFilterState() {
      const saved = loadActiveFilterState(this.selectedDomain);
      if (!saved) return;
      const fields = getAllFilterFields(this.staticPersonasForFilter, false, this.schemaAttributes);
      const { criteria, droppedFields } = reconcileFilterCriteria(
        saved.criteria || [],
        fields,
        this.schemaAttributes,
      );
      this.activeFilterCriteria = criteria;
      if (droppedFields.length) {
        this.showToast(formatDroppedFilterFieldsMessage(droppedFields, this.t), 'warning');
        saveActiveFilterState(this.selectedDomain, {
          criteria,
          isGeneratedView: false,
        });
      }
    },
    onApplyFilters(criteria) {
      this.activeFilterCriteria = criteria;
      saveActiveFilterState(this.selectedDomain, {
        criteria,
        isGeneratedView: false,
      });
      this.ensureSelectedPersonaStillVisible();
    },
    onClearFilters() {
      this.activeFilterCriteria = [];
      clearActiveFilterState(this.selectedDomain);
    },
    ensureSelectedPersonaStillVisible() {
      if (!this.selectedPersona) return;

      const stillVisible = this.filteredChatPersonas.some(
        (persona) => persona.persona_id === this.selectedPersona,
      );

      if (!stillVisible) {
        this.selectedPersona = '';
        this.selectedThreadId = '';
        this.messages = [];
        this.thread_ids = [];
      }
    },
    resolvePersonaFromQuery(value) {
      if (!value) return null;

      const byId = this.filteredChatPersonas.find(
        (persona) => persona.persona_id === value,
      );
      if (byId) return byId.persona_id;

      const normalized = String(value).trim().toLowerCase();
      const byName = this.filteredChatPersonas.find(
        (persona) => String(persona.name || '').trim().toLowerCase() === normalized,
      );
      return byName?.persona_id || null;
    },
// Load messages for the selected thread ID
    async loadMessages(threadId) {
      console.log("loading messages for: ", threadId);
      this.loadingMessages = true;
      if (threadId === "New Conversation") {
        this.messages = [];
        this.loadingMessages = false;
        return;
      }
      try {
        const response = await get_conversation_with_persona(threadId); // Fetch messages for the thread ID
        if (response && Array.isArray(response.data.chat_history) && Array.isArray(response.data.file_history)) {
          // Map the response to the correct format
          this.messages = response.data.chat_history.map((messageText, index) => {
            // Alternate sender between "You" and the selected persona
            const sender = index % 2 === 0 ? "You" : this.selectedPersonaName;
            const fileData = response.data.file_history[index]; // {kind, urls, preview_url} or null

            return {
              sender,
              text: messageText,
              file_data: fileData || null, // new format: {kind, urls, preview_url}
              file: null,
              file_type: null,
              file_name: null,
              file_url: null,
            };
          });
        } else {
          throw new Error("Invalid response format or missing history data");
        }
      } catch (error) {
        console.error("Error loading messages:", error);
        this.showToast(this.$t('chat.failedToLoadConversationMessages'), "error");
      } finally {
        this.loadingMessages = false;
      }
    },
    async askPersona() {
// Pre-check for loading to prevent double-send and check for empty question
      if (this.loading || !this.question || !this.selectedPersona) {
        if (!this.selectedPersona) this.showToast(this.$t('chat.pleaseSelectAPersona'));
        if (!this.question) this.showToast(this.$t('chat.pleaseEnterAQuestion'));
        return;
      }

      console.log("asking question to: ", this.selectedThreadId);
// If selectedThreadId is "New" or an empty string, get the threadId
      if (this.selectedThreadId === "New Conversation") {
        console.log("Calling generateNewConversation...");
        await this.generateNewConversation();
      }
      console.log("question: ", this.question);
// Prepare file info for user message
      const userFile = this.uploaded_file.length > 0 ? this.uploaded_file[0] : null;
      const userFileExt = userFile ? this.getFileExt(userFile.name) : null;
      const isUserImage = userFile && this.allowed_image_ext.includes(userFileExt);

// Push user message immediately before awaiting anything
      const questionToSend = this.question;
      this.question = "";
      this.messages.push({
        sender: "You",
        text: questionToSend,
        file: userFile ? userFile.file : null,
        file_type: userFile ? userFile.type : null,
        file_name: userFile ? userFile.name : null,
        file_url: isUserImage ? URL.createObjectURL(userFile.file) : null,
        file_data: null,
      });
      console.log(this.messages);
      console.log(this.uploaded_file)
      this.loading = true;
      try {
        let formData = new FormData();
        formData.append("persona_id", this.selectedPersona);
        formData.append("question", questionToSend);
        formData.append("thread_id", this.selectedThreadId);
        if (this.uploaded_file.length > 0) {
          formData.append("file", this.uploaded_file[0].file, this.uploaded_file[0].name);
        }
// Send the question to the backend
        const response = await ask_persona(formData);

// Extract file history for the bot's response
        const botResponseData = response.data;
        // L'ultima voce è la risposta del bot (se c'è)
        const botFileHistory = botResponseData.file_history && botResponseData.file_history.length > 0 ? botResponseData.file_history[botResponseData.file_history.length - 1] : null;

// Check if the bot's file has data (può essere immagine o documento)
        const hasBotFile = botFileHistory && botFileHistory.url;

        // Aggiungo anche per il bot il file_name e il file_type se disponibili, per la visualizzazione
        const botFileUrl = hasBotFile ? (botFileHistory.url || null) : null;
        const botFileName = hasBotFile ? (botFileHistory.filename || null) : null;
        const botFileType = hasBotFile ? (botFileHistory.mime_type || null) : null;


// Add persona's response
        this.messages.push({
          sender: this.selectedPersonaName,
          text: botResponseData.response || this.$t('chat.noResponse'),
          file: null, // Non gestiamo il download diretto da base64 in questa fase per il bot
          file_type: botFileType,
          file_name: botFileName,
          file_url: botFileUrl // Aggiunto l'URL del file del bot (sia immagine che documento)
        });

      } catch (error) {
        console.error("Error asking persona:", error);
// Add error message and show toast
        this.messages.push({ sender: "System", text: this.$t('chat.failedToGetAResponse'), file: null, file_type: null, file_name: null, file_url: null });
        this.showToast(this.$t('chat.failedToGetResponseFromPersona'));
      } finally {
        this.loading = false;
// clear image uploader
        this.cleanImage();
        this.uploaded_file = [];
      }
    },
// Method to get a new thread ID from the backend
    async generateNewConversation() {
      try {
// Call the backend API to generate a new thread_id
        const response = await generate_new_thread_id(this.selectedPersona);
        console.log("generated new thread_id for conversation: ", response);
        if (response && response.data && response.data.thread_id) {
          const newThreadId = response.data.thread_id;
          const newThreadTimestamp = response.data.timestamp; // Extract timestamp
          console.log("thread id generated: ", newThreadId);
          console.log("timestamp generated: ", newThreadTimestamp);
// Create a new thread object with both thread_id and timestamp
          const newThreadObject = { thread_id: newThreadId, timestamp: newThreadTimestamp // Use the received timestamp
          };
// Add the new thread object to the thread_ids list (replacing New Conversation at the start)
          this.thread_ids = [{ thread_id: "New Conversation", timestamp: "New Conversation" }, ...this.thread_ids.filter(t => t.thread_id !== "New Conversation")];
          this.thread_ids.push(newThreadObject);
// Set the selectedThreadId to the newly generated thread_id to select it
          this.selectedThreadId = newThreadId;
        } else {
          throw new Error("Failed to generate a new thread ID.");
        }
      } catch (error) {
        console.error("Error generating new thread ID:", error);
        this.showToast(this.$t('chat.failedToGenerateANewThreadID'));
      }
    },
    formattedThreadTimestamp(timestamp) {
      if (timestamp) {
        if (timestamp === "New Conversation") {
          return "New Conversation";
        }
        return formatDateTime(timestamp, this.$i18n.locale);
      }
      return "Unknown date";
    },
    renderMarkdown(markdown) {
      return marked(markdown);
    },
    showSnackbarNotSupported(){
      this.snackbar_not_supported = false;
      this.$nextTick(() => {
        this.snackbar_not_supported = true; // Trigger the snackbar
      });
    },
    showSnackbarDownloaded(){
      this.snackbar_downloaded = false;
      this.$nextTick(() => {
        this.snackbar_downloaded = true; // Trigger the snackbar
      });
    },
    showDownloadingSpinner(){
      this.downloading_spinner = true;
    },
    stopDownloadingSpinner(){
      this.downloading_spinner = false;
    },
    removeUploadedFile(){
      this.uploaded_file = [];
      this.cleanImage();
    },
    getFileExt(filename){
      var re = /(?:\.([^.]+))?$/;
      return '.' + re.exec(filename)[1];
    },
    cleanImage(){
      if(this.uploaded_image_url){
        this.uploaded_image_url = null;
        URL.revokeObjectURL(this.uploaded_image_url);
      }
    },
    async fileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },
    decodeBase64(content) {
      if(!content) return null;
      try {
        let byteCharacters = ""
        try {
          const base64Content = content.split(',')[1];
          byteCharacters = atob(base64Content);
        } catch (InvalidCharacterError) {
          byteCharacters = atob(content)
        }
        const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) => byteCharacters.charCodeAt(i));
        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], {type: 'application/pdf'});
      }catch(Error){
        console.log("Error while decoding file");
        return null
      }
    },
    performDownload(content, filename){
      if(!content || !filename) return
      const blob = this.decodeBase64(content);
      if(!blob) return
      const blobUrl = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(blobUrl);
      this.stopDownloadingSpinner();
      this.showSnackbarDownloaded();
    },
    async downloadMedia(content, filename) {
      if(!content || !filename) return
      this.showDownloadingSpinner();
      if(content instanceof File){
        const base64 = await this.fileToBase64(content);
        if(base64) this.downloadMedia(base64, filename);
        else this.stopDownloadingSpinner();
      } else {
        this.performDownload(content,filename);
      }
    }
  },
  watch: {
    selectedPersona(newPersona) {
      this.handlePersonaChange();
    },
    selectedThreadId(newThreadId) {
      if (newThreadId === "New Conversation") {
        this.messages = []; // This line clears the messages array
      }
    },
    uploaded_file(newVal){
// Filtro le immagini
      if(newVal.length > 0){
        const ext = this.getFileExt(newVal[0].name);
        if(this.allowed_image_ext.includes(ext)){
          this.uploaded_image_url = URL.createObjectURL(newVal[0].file);
        } else if(this.allowed_document_ext.includes(ext)){
          this.cleanImage();
        } else{
          this.uploaded_file = [];
          this.cleanImage();
          this.showSnackbarNotSupported();
        }
      }
    },
    selectedDomain(newValue, oldValue){
      if(newValue !== oldValue){
        this.selectedPersona = "";
        this.loadFilterPersonaSources(newValue);
        this.fetchPersonaNames(newValue);
      }
    },
    activeFilterCriteria: {
      deep: true,
      handler() {
        this.ensureSelectedPersonaStillVisible();
      },
    },
  },
  async created() {
    try {
      await this.loadFilterPersonaSources(this.selectedDomain, false);
      this.restoreActiveFilterState();
      await this.fetchPersonaNames(this.selectedDomain);
      const personaFromQuery = this.resolvePersonaFromQuery(this.$route.query.selectedPersona);
      if (personaFromQuery) {
        this.selectedPersona = personaFromQuery;
      }
    } catch (error) {
      console.error("Error initializing component:", error);
      this.showToast(this.$t('chat.failedToLoadDataPleaseTryAgainLater'));
    }
  }
};
</script><style scoped> ::v-deep label { cursor: pointer; } .chat-application { min-height: 100vh; } .sidebar-card, .chat-card { border: 1px solid rgba(0, 0, 0, 0.05); overflow: hidden; } .media-downloader { display: flex; flex-direction: row; align-items: center; gap: 0.75rem; padding: 0.5rem; background-color: ghostwhite; border: 1px solid ghostwhite; border-radius: 1rem; } .conversations-container { max-height: 500px; overflow-y: auto; } .conversation-item:hover { background-color: rgb(var(--v-theme-primary-lighten-5)); transition: background-color 0.2s ease; } .messages-container { height: 100%; max-height: calc(100vh - 350px); overflow-y: auto; scroll-behavior: smooth; } .messages-list { display: flex; flex-direction: column; width: 100%; } .message-wrapper { display: flex; margin-bottom: 8px; width: 100%; } .user-message-wrapper { justify-content: flex-end; } .bot-message-wrapper { justify-content: flex-start; } .message-card { min-width: 150px; max-width: 80%; word-wrap: break-word; transition: all 0.2s ease; opacity: 1; } .user-message { background-color: rgb(var(--v-theme-primary-lighten-5)); border-bottom-right-radius: 4px !important; } .bot-message { background-color: white; border-bottom-left-radius: 4px !important; } .system-message { background-color: rgb(var(--v-theme-warning_lighten_1)); border-bottom-left-radius: 4px !important; } .message-content { white-space: normal; } .message-text { line-height: 1.5; } .message-text :deep(pre) { background-color: rgba(0, 0, 0, 0.05); padding: 12px; border-radius: 8px; overflow-x: auto; } .message-text :deep(code) { background-color: rgba(0, 0, 0, 0.05); padding: 2px 4px; border-radius: 4px; font-family: monospace; } .message-input :deep(.v-field__outline) { border-color: rgba(0, 0, 0, 0.1) !important; } </style>